var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"comment-tooltip-animation"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.comment && _vm.hideIcon && _vm.showCommentTooltip),expression:"comment && hideIcon && showCommentTooltip"}],staticClass:"comment-tooltip"},[_vm._v(_vm._s(_vm.comment))])])
}
var staticRenderFns = []

export { render, staticRenderFns }